<form class="app-form" [formRoot]="form">
  <h4>{{ 'LABELS.CREATE_NEW_PASSWORD' | translate }}</h4>
  <p>{{ 'MESSAGES.WARNINGS.PREVIOUS_PASSWORD_MUST_BE_DIFFERENT' | translate }}</p>

  <div class="form-group">
    <label class="col-form-label">{{ 'LABELS.PASSWORD' | translate }}</label>
    <div class="relative" data-field-wrapper>
      <input
        [type]="revealPassword() ? 'text' : 'password'"
        class="form-control pr-16"
        [formField]="form.password"
        autocomplete="new-password"
        placeholder="{{ 'MESSAGES.PROMPTS.ENTER_NEW_PASSWORD' | translate }}"
        appFormFieldOnError
        [customMessages]="{
          required: 'MESSAGES.ERRORS.PASSWORD_REQUIRED' | translate,
          minlength: 'MESSAGES.ERRORS.PASSWORD_MIN_LENGTH' | translate,
        }"
      />
      <app-password-visibility-toggle [revealed]="revealPassword()" (toggled)="togglePasswordVisibility()" />
    </div>
  </div>

  <div class="form-group">
    <label class="col-form-label">{{ 'LABELS.CONFIRM_NEW_PASSWORD' | translate }}</label>
    <input
      [type]="revealPassword() ? 'text' : 'password'"
      class="form-control"
      [formField]="form.confirmPassword"
      autocomplete="new-password"
      placeholder="Enter your new confirm password"
      appFormFieldOnError
      [customMessages]="{
        required: 'MESSAGES.ERRORS.PASSWORD_CONFIRMATION_REQUIRED' | translate,
        minlength: 'MESSAGES.ERRORS.PASSWORD_CONFIRMATION_MIN_LENGTH' | translate,
        mustMatch: 'MESSAGES.ERRORS.PASSWORDS_DO_NOT_MATCH' | translate,
      }"
    />
  </div>
  <div class="form-group mt-6 mb-0">
    <button type="submit" [disabled]="form().invalid() || form().submitting()" class="btn btn-gradient btn-block">
      <span>{{ 'LABELS.RESET_PASSWORD' | translate }}</span>
    </button>
  </div>
  <hr />
  <p class="mt-6 mb-0">
    {{ 'MESSAGES.PROMPTS.ALREADY_HAVE_ACCOUNT' | translate }}
    <a [routerLink]="'/'" class="ml-2">{{ 'LABELS.SIGN_IN' | translate }}</a>
  </p>
</form>
